module.exports = __webpack_public_path__ + "img/prizesTab1.bb2e732a.png";